import { FC } from 'react';
import withTransferForm, { PageIdEnum, TransferFormProps } from '../../../withTransferForm';
import { PARTIAL_ACATS_BASE_PATH } from '../helper';
import { ChooseTransferTypePageFormutil } from '../type';
import Full from './Full';
import Partial from './Partial';

const Preview: FC<TransferFormProps> = props => {
    const { getStorageDataByKey } = props;
    const { transfer_type } = getStorageDataByKey<ChooseTransferTypePageFormutil>(PageIdEnum.CHOOSE_TRANSFER_TYPE);

    if (transfer_type === 'full') {
        return <Full {...props} />;
    }

    return <Partial {...props} />;
};

export default withTransferForm({
    id: PageIdEnum.PREVIEW,
    step: 4,
    basePath: PARTIAL_ACATS_BASE_PATH,
    ensure: [PageIdEnum.BROKER, PageIdEnum.CHECK, PageIdEnum.CHOOSE_TRANSFER_TYPE]
})(Preview);
